(function () {
  'use strict';

  if (window.bandzKeychainProcessorLoaded) return;
  window.bandzKeychainProcessorLoaded = true;

  var observedForms = new WeakSet();
  var pollDelayMs = 1500;
  var maxPolls = 80;

  function query(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function setControl(control, value, enabled) {
    if (!control) return;
    control.value = value || '';
    control.disabled = !enabled;
  }

  function keepBaseFieldsEnabled(root) {
    var selector = [
      '[name="properties[Brand or Organization Name]"]',
      '[name="properties[Special Instructions]"]',
      '[name="properties[Design Adjustment Approval]"]',
      '[name="properties[Base Color]"]'
    ].join(', ');

    root.querySelectorAll(selector).forEach(function (field) {
      field.disabled = false;
    });

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var field = mutation.target;
        if (
          mutation.attributeName === 'disabled' &&
          field.matches(selector) &&
          field.disabled
        ) {
          field.disabled = false;
        }
      });
    }).observe(root, {
      attributes: true,
      attributeFilter: ['disabled'],
      subtree: true
    });
  }

  function resizeProductSection(root, form) {
    var section = root.closest('[id^="shopify-section-"]');
    if (!section || !form) return;

    window.requestAnimationFrame(function () {
      var sectionTop = section.getBoundingClientRect().top + window.scrollY;
      var formBottom = form.getBoundingClientRect().bottom + window.scrollY;
      section.style.minHeight = Math.ceil(formBottom - sectionTop + 50) + 'px';
      section.style.overflow = 'visible';
    });
  }

  function disableStickyProductInfo(root) {
    var productInfo = document.getElementById('product-info');
    if (!productInfo || !root.closest('.product-section')) return;

    document.documentElement.classList.add('keychain-product-page');

    function resetStickyInfo() {
      if (
        window.ScrollTrigger &&
        typeof window.ScrollTrigger.getAll === 'function'
      ) {
        window.ScrollTrigger.getAll().forEach(function (trigger) {
          if (trigger.pin === productInfo) trigger.kill(true);
        });
      }

      [
        'position',
        'top',
        'right',
        'bottom',
        'left',
        'width',
        'height',
        'transform'
      ].forEach(function (property) {
        productInfo.style.removeProperty(property);
      });
    }

    resetStickyInfo();
    window.requestAnimationFrame(resetStickyInfo);
    window.setTimeout(resetStickyInfo, 250);
    window.setTimeout(resetStickyInfo, 1000);
    window.addEventListener('scroll', resetStickyInfo, { passive: true });
  }

  function processorUrl(root, path) {
    var base = (root.dataset.processorEndpoint || '').trim().replace(/\/+$/, '');
    return base ? base + path : '';
  }

  function readVariants(root) {
    var script = query(root, '[data-keychain-variants]');
    if (!script) return [];

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error('Unable to read keychain variants.', error);
      return [];
    }
  }

  function currentVariant(root, form) {
    var idInput = query(form, '[name="id"]');
    var id = idInput ? String(idInput.value) : '';

    return readVariants(root).find(function (variant) {
      return String(variant.id) === id;
    }) || null;
  }

  function optionValue(root, variant, indexName) {
    var index = Number(root.dataset[indexName]);
    if (!variant || !variant.options || Number.isNaN(index)) return '';
    return variant.options[index] || '';
  }

  function updateNfcFields(root, form) {
    var variant = currentVariant(root, form);
    var technology = optionValue(root, variant, 'technologyIndex');
    var isNfc = technology.toLowerCase().indexOf('nfc') !== -1;
    var panel = query(root, '[data-nfc-fields]');

    if (!panel) return;
    panel.hidden = !isNfc;

    panel.querySelectorAll('input, select, textarea').forEach(function (field) {
      field.disabled = !isNfc;
      if (field.hasAttribute('data-nfc-required')) field.required = isNfc;
    });
  }

  function uploadlyFile(form) {
    var input = query(form, 'input[name="properties[upload logo]"]');
    if (!input) return null;

    var sourceUrl = (input.dataset.cdn || '').trim();
    if (!sourceUrl) return null;

    var uploadContainer =
      input.closest('[data-ph-fieldname]') ||
      query(form, '[data-ph-fieldname="upload logo"]');
    var removeButton = uploadContainer
      ? query(uploadContainer, '[title^="Remove "]')
      : null;
    var filename = removeButton
      ? removeButton.getAttribute('title').replace(/^Remove\s+/, '')
      : 'Uploaded artwork';

    return {
      sourceUrl: sourceUrl,
      filename: filename,
      container: uploadContainer
    };
  }

  function controls(panel) {
    return {
      preview: query(panel, '[data-property-preview]'),
      cleaned: query(panel, '[data-property-cleaned]'),
      simplified: query(panel, '[data-property-simplified]'),
      palette: query(panel, '[data-property-palette]'),
      simplificationStatus: query(
        panel,
        '[data-property-simplification-status]'
      ),
      job: query(panel, '[data-property-job]'),
      status: query(panel, '[data-property-status]'),
      warnings: query(panel, '[data-property-warnings]'),
      privateWarnings: query(panel, '[data-property-private-warnings]'),
      source: query(panel, '[data-property-source]'),
      version: query(panel, '[data-property-version]')
    };
  }

  function clearGenerated(panel) {
    var fields = controls(panel);
    Object.keys(fields).forEach(function (key) {
      setControl(fields[key], '', false);
    });

    var previewApproval = query(panel, '[data-preview-approval]');
    var manualApproval = query(panel, '[data-manual-approval]');
    [previewApproval, manualApproval].forEach(function (field) {
      if (!field) return;
      field.checked = false;
      field.disabled = true;
      field.required = false;
      field.setCustomValidity('');
    });
  }

  function setButtonLock(root, form, locked) {
    var button = query(form, 'button[name="add"], .add-to-cart-button');
    if (!button) return;

    if (locked) {
      button.dataset.keychainLocked = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      return;
    }

    delete button.dataset.keychainLocked;
    button.removeAttribute('aria-busy');

    var variant = currentVariant(root, form);
    if (variant && variant.available) button.disabled = false;
  }

  function setState(root, form, panel, state, options) {
    options = options || {};
    var status = query(panel, '[data-preview-status]');
    var progress = query(panel, '[data-preview-progress]');
    var result = query(panel, '[data-preview-result]');
    var message = query(panel, '[data-preview-message]');
    var warnings = query(panel, '[data-preview-warnings]');
    var warningList = query(panel, '[data-preview-warning-list]');
    var previewApprovalWrap = query(panel, '[data-preview-approval-wrap]');
    var previewApproval = query(panel, '[data-preview-approval]');
    var manualApprovalWrap = query(panel, '[data-manual-approval-wrap]');
    var manualApproval = query(panel, '[data-manual-approval]');

    panel.dataset.state = state;
    panel.hidden = state === 'idle';
    progress.hidden = state !== 'processing';
    result.hidden = !options.previewUrl;
    message.hidden = !options.message;
    warnings.hidden = !options.warnings || options.warnings.length === 0;
    previewApprovalWrap.hidden = state !== 'ready' && state !== 'warning';
    manualApprovalWrap.hidden = state !== 'manual_review' && state !== 'failed';

    if (status) {
      status.textContent = {
        processing: 'Processing artwork',
        ready: 'Preview ready',
        warning: 'Ready with warnings',
        manual_review: 'Manual review required',
        failed: 'Processing unavailable'
      }[state] || 'Waiting for artwork';
    }

    if (message) message.textContent = options.message || '';

    if (warningList) {
      warningList.innerHTML = '';
      (options.warnings || []).forEach(function (warning) {
        var item = document.createElement('li');
        item.textContent = warning;
        warningList.appendChild(item);
      });
    }

    if (previewApproval) {
      previewApproval.disabled = state !== 'ready' && state !== 'warning';
      previewApproval.required = !previewApproval.disabled;
    }

    if (manualApproval) {
      var manualAllowed = root.dataset.allowManualReview !== 'false';
      manualApproval.disabled =
        !manualAllowed || (state !== 'manual_review' && state !== 'failed');
      manualApproval.required = !manualApproval.disabled;
    }

    setButtonLock(root, form, state === 'processing');
    refreshCheckoutGate(root, form, panel);
    resizeProductSection(root, form);
  }

  function refreshCheckoutGate(root, form, panel) {
    var state = panel.dataset.state;
    var previewApproval = query(panel, '[data-preview-approval]');
    var manualApproval = query(panel, '[data-manual-approval]');
    var allowed =
      ((state === 'ready' || state === 'warning') &&
        previewApproval && previewApproval.checked) ||
      ((state === 'manual_review' || state === 'failed') &&
        manualApproval && manualApproval.checked);

    if (!allowed && state !== 'idle') {
      setButtonLock(root, form, true);
    } else if (allowed) {
      setButtonLock(root, form, false);
    }
  }

  function placePanel(upload, panel) {
    if (
      upload.container &&
      upload.container.nextElementSibling !== panel
    ) {
      upload.container.insertAdjacentElement('afterend', panel);
    }
  }

  function publicJobUrl(root, jobId) {
    return processorUrl(root, '/v1/jobs/' + encodeURIComponent(jobId));
  }

  function selectedBaseColor(root) {
    var selected = query(root, '[data-base-color]:checked');
    return selected && String(selected.value).toLowerCase() === 'white'
      ? 'white'
      : 'black';
  }

  function applyJob(root, form, panel, upload, job) {
    var fields = controls(panel);
    var warnings = Array.isArray(job.warnings) ? job.warnings : [];
    var warningText = warnings.join(' | ');
    var previewImage = query(panel, '[data-preview-image]');
    var previewLink = query(panel, '[data-preview-link]');

    setControl(fields.source, upload.sourceUrl, true);
    setControl(fields.job, job.jobId, Boolean(job.jobId));
    setControl(fields.status, job.statusLabel || job.status, true);
    setControl(fields.warnings, warningText, Boolean(warningText));
    setControl(
      fields.privateWarnings,
      job.technicalWarnings ? job.technicalWarnings.join(' | ') : warningText,
      Boolean(job.technicalWarnings || warningText)
    );
    setControl(fields.version, job.processorVersion, Boolean(job.processorVersion));
    setControl(
      fields.simplificationStatus,
      job.simplificationStatus || '',
      Boolean(job.simplificationStatus)
    );
    setControl(
      fields.palette,
      Array.isArray(job.palette) ? job.palette.join(', ') : '',
      Array.isArray(job.palette) && job.palette.length > 0
    );

    if (job.previewUrl && previewImage && previewLink) {
      previewImage.src = job.previewUrl;
      previewLink.href = job.previewUrl;
      setControl(fields.preview, job.previewUrl, true);
    }

    if (job.simplifiedArtworkUrl) {
      setControl(fields.simplified, job.simplifiedArtworkUrl, true);
    }

    if (job.cleanedArtworkUrl) {
      setControl(fields.cleaned, job.cleanedArtworkUrl, true);
    }

    if (job.status === 'ready' || job.status === 'ready_with_warnings') {
      setState(
        root,
        form,
        panel,
        job.status === 'ready' ? 'ready' : 'warning',
        {
          previewUrl: job.previewUrl,
          warnings: warnings,
          message: job.message || ''
        }
      );
      return true;
    }

    if (job.status === 'manual_review') {
      setState(root, form, panel, 'manual_review', {
        previewUrl: job.previewUrl,
        warnings: warnings,
        message:
          job.message ||
          'This artwork needs an artist-reviewed proof before production.'
      });
      return true;
    }

    if (job.status === 'failed') {
      setState(root, form, panel, 'failed', {
        warnings: warnings,
        message:
          job.message ||
          'Automatic processing is unavailable. Continue with a manual artwork review.'
      });
      return true;
    }

    return false;
  }

  function pollJob(root, form, panel, upload, jobId, sourceKey, attempt) {
    if (panel.dataset.sourceKey !== sourceKey) return;

    if (attempt >= maxPolls) {
      applyJob(root, form, panel, upload, {
        jobId: jobId,
        status: 'failed',
        statusLabel: 'Manual review required',
        message:
          'Processing took longer than expected. Continue with a manual artwork review.'
      });
      return;
    }

    window.setTimeout(function () {
      fetch(publicJobUrl(root, jobId), {
        method: 'GET',
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to read processing job.');
          return response.json();
        })
        .then(function (job) {
          if (panel.dataset.sourceKey !== sourceKey) return;
          if (!applyJob(root, form, panel, upload, job)) {
            pollJob(root, form, panel, upload, jobId, sourceKey, attempt + 1);
          }
        })
        .catch(function () {
          pollJob(root, form, panel, upload, jobId, sourceKey, attempt + 1);
        });
    }, pollDelayMs);
  }

  function startJob(root, form, panel, upload) {
    var endpoint = processorUrl(root, '/v1/jobs');
    var variant = currentVariant(root, form);
    var technology = optionValue(root, variant, 'technologyIndex');
    var size = optionValue(root, variant, 'sizeIndex');
    var baseColor = selectedBaseColor(root);
    var sourceKey = [
      upload.sourceUrl,
      variant ? variant.id : '',
      baseColor
    ].join('|');

    if (panel.dataset.sourceKey === sourceKey) return;

    panel.dataset.sourceKey = sourceKey;
    clearGenerated(panel);
    placePanel(upload, panel);
    query(panel, '[data-preview-filename]').textContent = upload.filename;
    setControl(controls(panel).source, upload.sourceUrl, true);

    if (!endpoint) {
      applyJob(root, form, panel, upload, {
        status: 'manual_review',
        statusLabel: 'Manual review required',
        message:
          'Automatic preview processing is not connected yet. Continue with an artist-reviewed proof.'
      });
      return;
    }

    setState(root, form, panel, 'processing');

    fetch(endpoint, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sourceUrl: upload.sourceUrl,
        filename: upload.filename,
        productId: root.dataset.productId,
        productHandle: root.dataset.productHandle,
        variantId: variant ? String(variant.id) : '',
        size: size,
        technology: technology,
        maximumColors: 4,
        baseColor: baseColor
      })
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) {
            throw new Error(body.message || 'Unable to start artwork processing.');
          }
          return body;
        });
      })
      .then(function (job) {
        if (panel.dataset.sourceKey !== sourceKey) return;
        setControl(controls(panel).job, job.jobId, Boolean(job.jobId));

        if (!applyJob(root, form, panel, upload, job)) {
          pollJob(root, form, panel, upload, job.jobId, sourceKey, 0);
        }
      })
      .catch(function (error) {
        if (panel.dataset.sourceKey !== sourceKey) return;
        applyJob(root, form, panel, upload, {
          status: 'failed',
          statusLabel: 'Manual review required',
          message:
            error.message ||
            'Automatic processing is unavailable. Continue with a manual artwork review.'
        });
      });
  }

  function reset(root, form, panel) {
    panel.dataset.sourceKey = '';
    panel.hidden = true;
    panel.dataset.state = 'idle';
    clearGenerated(panel);
    setButtonLock(root, form, false);
    resizeProductSection(root, form);

    var previewImage = query(panel, '[data-preview-image]');
    if (previewImage) previewImage.removeAttribute('src');
  }

  function update(root, form, panel) {
    updateNfcFields(root, form);
    var upload = uploadlyFile(form);

    if (!upload) {
      reset(root, form, panel);
      return;
    }

    startJob(root, form, panel, upload);
  }

  function requireApproval(root, form, panel) {
    var state = panel.dataset.state;
    if (state === 'idle') return true;

    var field =
      state === 'ready' || state === 'warning'
        ? query(panel, '[data-preview-approval]')
        : query(panel, '[data-manual-approval]');

    if (field && !field.disabled && field.checked) return true;

    if (field && !field.disabled) {
      field.setCustomValidity(
        state === 'ready' || state === 'warning'
          ? 'Please approve the generated keychain preview.'
          : 'Please confirm the manual artwork review.'
      );
      field.reportValidity();
    }

    panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return false;
  }

  function initialize(root) {
    var form = root.closest('form.add-to-cart-form[data-product-form]');
    var panel = document.getElementById(root.dataset.keychainPreviewId);
    if (!form || !panel || observedForms.has(form)) return;

    observedForms.add(form);
    disableStickyProductInfo(root);
    keepBaseFieldsEnabled(root);

    var button = query(form, 'button[name="add"], .add-to-cart-button');
    if (button) {
      new MutationObserver(function () {
        if (button.dataset.keychainLocked === 'true' && !button.disabled) {
          button.disabled = true;
        }
      }).observe(button, {
        attributes: true,
        attributeFilter: ['disabled']
      });
    }

    new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        return (
          mutation.type === 'childList' ||
          mutation.attributeName === 'data-cdn' ||
          mutation.attributeName === 'data-status' ||
          mutation.attributeName === 'value'
        );
      });

      if (relevant) window.setTimeout(function () {
        update(root, form, panel);
      }, 0);
    }).observe(form, {
      attributes: true,
      attributeFilter: ['data-cdn', 'data-status', 'value'],
      childList: true,
      subtree: true
    });

    form.addEventListener('change', function (event) {
      if (
        event.target.matches('[data-preview-approval], [data-manual-approval]')
      ) {
        event.target.setCustomValidity('');
        refreshCheckoutGate(root, form, panel);
        return;
      }

      window.setTimeout(function () {
        update(root, form, panel);
        resizeProductSection(root, form);
      }, 50);
    });

    form.addEventListener('submit', function (event) {
      if (!requireApproval(root, form, panel)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    form.addEventListener('click', function (event) {
      var addButton = event.target.closest(
        'button[name="add"], .ph_atc_btn, .ph_clone_atc_btn'
      );
      if (!addButton) return;

      if (!requireApproval(root, form, panel)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    update(root, form, panel);
    resizeProductSection(root, form);
    window.addEventListener('resize', function () {
      resizeProductSection(root, form);
    });
  }

  function initializeAll() {
    document
      .querySelectorAll('[data-keychain-custom-fields]')
      .forEach(initialize);
  }

  document.addEventListener('DOMContentLoaded', initializeAll);
  document.addEventListener('shopify:section:load', initializeAll);
  window.addEventListener('load', initializeAll);
  window.setTimeout(initializeAll, 0);
  window.setTimeout(initializeAll, 1000);
})();
